import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-opdactivity-summary',
  templateUrl: './daily-opdactivity-summary.component.html',
  styleUrls: ['./daily-opdactivity-summary.component.css']
})
export class DailyOPDActivitySummaryComponent {

}
